export const AUTH0_CONST = {
    checkPreAuthParam: "checkForPreAuth",
    preAuthedToken: "preAuthedToken",
    clearUserParam: "clearAll",
    parseResultParamCode: "code",
    parseResultParamState: "state",
    ampRegiWallParam: "ampRegiWall",
    prefIdParam: "prefId",
    loginSourceParam: "loginsource",
    loginSourceGoogleOneTap: "googleonetap",
    returnAfterLogoutParam: "returnAfterLogout",
    authRedirectParam: "auth_redirect",
};